import { useEffect } from 'react';

const useKeyboardNavigation = ({ onPrev, onNext, isOpen, toggle }) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'ArrowLeft' && onPrev) {
        onPrev();
      } else if (event.key === 'ArrowRight' && onNext) {
        onNext();
      } else if (event.key === 'Escape' && isOpen && toggle) {
        toggle();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onPrev, onNext, isOpen, toggle]);
};

export default useKeyboardNavigation;
